import * as React from 'react';
import * as Status from '../PlanOrderStatus';
import * as Feature from '../../../../../shared/Features';
import { FormControl, FormGroup, ControlLabel, Row, Col, Button } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import { IStatusModel } from './entities';

interface IStatusFormProps {
    sketchUpStatus: IStatusModel;
    roomSketcherStatus: IStatusModel;
    user: any;
    hideDeliveryFailure: (sketchUpStatus: number, roomSketcherStatus: number) => void;
}

const StatusForm = (props: IStatusFormProps) => {
    if (!props.sketchUpStatus || !props.roomSketcherStatus) {
        return null;
    }

    return (
        <Row>
            <Col xs={8}>
                <FormGroup>
                    {props.sketchUpStatus.id !== Status.notOrdered &&
                        props.roomSketcherStatus.id !== Status.notOrdered && (
                            <ControlLabel>
                                {Translate('view-order/admin-planorder/status-sketchup')} /{' '}
                                {Translate('view-order/admin-planorder/status-room-sketcher')}
                            </ControlLabel>
                        )}
                    {(props.sketchUpStatus.id === Status.notOrdered ||
                        props.roomSketcherStatus.id === Status.notOrdered) && (
                        <ControlLabel>
                            {Translate('view-order/admin-planorder/status')}
                        </ControlLabel>
                    )}
                    <FormControl.Static>
                        {props.sketchUpStatus.id !== Status.notOrdered &&
                            props.roomSketcherStatus.id !== Status.notOrdered && (
                                <span>
                                    {Translate(props.sketchUpStatus.name)} /{' '}
                                    {Translate(props.roomSketcherStatus.name)}
                                </span>
                            )}
                        {(props.sketchUpStatus.id === Status.notOrdered ||
                            props.roomSketcherStatus.id === Status.notOrdered) && (
                            <span>
                                {props.sketchUpStatus.id !== Status.notOrdered
                                    ? Translate(props.sketchUpStatus.name)
                                    : Translate(props.roomSketcherStatus.name)}
                            </span>
                        )}
                    </FormControl.Static>
                </FormGroup>
            </Col>
            <Col xs={4}>
                <FormGroup>
                    <FormControl.Static>
                        {props.sketchUpStatus.id !== Status.notOrdered &&
                            props.roomSketcherStatus.id !== Status.notOrdered &&
                            Feature.hasFeature(Feature.HideDeliveryFailure, props.user) &&
                            props.sketchUpStatus.id === Status.deliveryError &&
                            props.roomSketcherStatus.id === Status.deliveryError && (
                                <Button
                                    bsStyle="default"
                                    className="pull-right"
                                    onClick={() =>
                                        props.hideDeliveryFailure(
                                            Status.delivered,
                                            Status.delivered
                                        )
                                    }
                                >
                                    {Translate(
                                        'view-order/admin-planorder/hide-delivery-failure/button-label'
                                    )}
                                </Button>
                            )}
                        {(props.sketchUpStatus.id === Status.notOrdered ||
                            props.roomSketcherStatus.id === Status.notOrdered) &&
                            Feature.hasFeature(Feature.HideDeliveryFailure, props.user) &&
                            (props.sketchUpStatus.id === Status.deliveryError ||
                                props.roomSketcherStatus.id === Status.deliveryError) && (
                                <Button
                                    bsStyle="default"
                                    className="pull-right"
                                    onClick={() =>
                                        props.hideDeliveryFailure(
                                            props.sketchUpStatus.id === Status.deliveryError
                                                ? Status.delivered
                                                : Status.notOrdered,
                                            props.roomSketcherStatus.id === Status.deliveryError
                                                ? Status.delivered
                                                : Status.notOrdered
                                        )
                                    }
                                >
                                    {Translate(
                                        'view-order/admin-planorder/hide-delivery-failure/button-label'
                                    )}
                                </Button>
                            )}
                    </FormControl.Static>
                </FormGroup>
            </Col>
        </Row>
    );
};

export default StatusForm;
